import { aDeviceVersionBuilder } from "../entities/mocks/aDeviceVersion";
import { aFinalFirmwareBuilder } from "../entities/mocks/aFinalFirmware";
import { aOsuFirmwareBuilder } from "../entities/mocks/aOsuFirmware";
export class StubManagerApiRepository {
    fetchLatestFirmware = () => {
        const result = aOsuFirmwareBuilder();
        return Promise.resolve(result);
    };
    fetchMcus = () => {
        return Promise.resolve([]);
    };
    getDeviceVersion = () => {
        const result = aDeviceVersionBuilder();
        return Promise.resolve(result);
    };
    getCurrentOSU = () => {
        const result = aOsuFirmwareBuilder();
        return Promise.resolve(result);
    };
    getCurrentFirmware = () => {
        const result = aFinalFirmwareBuilder();
        return Promise.resolve(result);
    };
    getFinalFirmwareById = () => {
        const result = aFinalFirmwareBuilder();
        return Promise.resolve(result);
    };
    getAppsByHash = () => {
        return Promise.resolve([]);
    };
    catalogForDevice = () => {
        return Promise.resolve([]);
    };
    getLanguagePackagesForDevice = () => {
        return Promise.resolve([]);
    };
}
//# sourceMappingURL=StubManagerApiRepository.js.map